import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";

const appVersion = document.querySelector('meta[name="app-version"]')?.getAttribute('content') ?? 'unknown';
console.log(`App versie: ${appVersion}`);

// Register service worker for PWA + update detection
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      console.log('SW registered:', reg.scope);

      // Check for updates every 60 seconds
      setInterval(() => reg.update(), 60_000);

      // Listen for a new SW waiting to activate
      const onUpdateFound = () => {
        const newWorker = reg.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // New version available — dispatch custom event for React to pick up
            window.dispatchEvent(new CustomEvent('sw-update-available'));
          }
        });
      };

      reg.addEventListener('updatefound', onUpdateFound);
    }).catch((err) => {
      console.warn('SW registration failed:', err);
    });
  });

  // When the new SW takes over, reload
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
}

createRoot(document.getElementById("root")!).render(<App />);
